import { RenegotiateOptions } from '@wui/jssip/lib/RTCSession'

export const getReinviteOptions = (audioEnabled?: boolean, videoEnabled?: boolean, useMediaStubs = false, ...extraHeaders: string[]): RenegotiateOptions => {
  const options: RenegotiateOptions = {
    useUpdate: false,
    rtcOfferConstraints: {
      offerToReceiveAudio: useMediaStubs ? true : (audioEnabled!),
      offerToReceiveVideo: useMediaStubs ? true : (videoEnabled!),
    },
    extraHeaders: [
      ...extraHeaders,
      `X-Satel-Params: MuteMyVideo=${!videoEnabled};MuteMyAudio=${!audioEnabled}`,
    ],
  }
  return options
}
